'use client';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Component } from 'react';

let ErrorDetails = ({ open: t, error: s, errorInfo: n, msg: o = 'Something went wrong!' })=>jsxs("div", {
        children: [
            'string' == typeof o ? jsx("h2", {
                children: o
            }) : o,
            jsxs("details", {
                style: {
                    whiteSpace: 'pre-wrap'
                },
                open: t,
                children: [
                    jsx("summary", {
                        children: "Error details"
                    }),
                    jsx("p", {
                        children: s && s.toString()
                    }),
                    jsx("h4", {
                        className: "swan-mt-4",
                        children: "Stack trace:"
                    }),
                    jsx("div", {
                        children: n && n.componentStack
                    })
                ]
            })
        ]
    });
class ErrorBoundary extends Component {
    static getDerivedStateFromError(r) {
        return {
            error: r
        };
    }
    componentDidCatch(r, e) {
        this.setState({
            error: r,
            errorInfo: e
        });
    }
    render() {
        let { children: s, fallback: n, forceShowError: o = false, errorDetailMsg: i } = this.props;
        return this.state.error ? jsxs(Fragment, {
            children: [
                n,
                o || !n ? jsx(ErrorDetails, {
                    error: this.state.error,
                    errorInfo: this.state.errorInfo,
                    open: !n,
                    msg: i
                }) : null
            ]
        }) : jsx(Fragment, {
            children: s
        });
    }
    constructor(r){
        super(r), this.state = {
            error: null,
            errorInfo: null
        };
    }
}

export { ErrorBoundary };
